<app-applicant-header *ngIf="applicationId != null" [applicationId]="applicationId"></app-applicant-header>

<app-applicant-profile *ngIf="applicationId != null" [applicationId]="applicationId"></app-applicant-profile>

<div class="pb-5"></div>

<app-applicant-detail-tab-list *ngIf="applicationId != null" [applicationId]="applicationId"></app-applicant-detail-tab-list>